import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom, of } from 'rxjs';
import { catchError, filter, take, timeout } from 'rxjs/operators';
import { selectActor } from '../store/auth/auth.selectors';

export const SalesActorGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);

    const actor = await firstValueFrom(
        store.select(selectActor).pipe(
            filter((a) => a !== null && a !== undefined),
            take(1),
            timeout(3000),
            catchError(() => of(null))
        )
    );

    const roleCode = String(actor?.role_code || '').trim().toLowerCase();
    if (roleCode === 'sales' && actor?.actor_type === 'org') return true;
    if (roleCode === 'subpartner') return router.parseUrl('/developer/dashboard');
    if (roleCode === 'app_admin') return router.parseUrl('/admin/dashboard');
    if (actor?.actor_type === 'investor') return router.parseUrl('/properties');
    return router.parseUrl('/developer/dashboard');
};
